import { getAxiosInstance } from '../client';
/** Mutation functions for tour status */
export const tourMutations = {
    /** POST /tour-status/complete */
    complete: (dto) => getAxiosInstance()
        .post('tour-status/complete', dto)
        .then((r) => r.data),
};
//# sourceMappingURL=tour.mutations.js.map